import { getNameNumberChaldean } from './Chaldean.js';
import { getNameNumberEnkanitham } from './Enkanitham.js';
import { getNameNumberPythagorean } from './Pythagorean.js';
export const DEFAULT_NUMEROLOGY = 'enkanitham';
/**
 * Methods are registered as they are implemented; `getStateFromParams` only
 * accepts the ones listed, so an unimplemented method cannot reach a name.
 */
const nameValueByNumerology = {
    enkanitham: getNameNumberEnkanitham,
    chaldean: getNameNumberChaldean,
    pythagorean: getNameNumberPythagorean,
};
export const implementedNumerologies = Object.keys(nameValueByNumerology);
export const isImplementedNumerology = (value) => implementedNumerologies.includes(value);
export function reduceToSingleDigit(value) {
    let result = Math.abs(Math.trunc(value));
    while (result > 9) {
        let sum = 0;
        for (let rest = result; rest > 0; rest = Math.floor(rest / 10)) {
            sum += rest % 10;
        }
        result = sum;
    }
    return result;
}
/**
 * Null when the method assigns the name no value. Each method reads one script -
 * Enkanitham Tamil, the other two Latin - so which names are valued depends on
 * the method as much as on the name.
 */
export function getNameNumber(name, numerology = DEFAULT_NUMEROLOGY) {
    const value = nameValueByNumerology[numerology];
    if (!value) {
        return null;
    }
    const total = value(name);
    return total === null
        ? null
        : { total, number: reduceToSingleDigit(total) };
}
// Every method reads the birth number the same way, so it is not pluggable.
export const getBirthNumber = (dayOfMonth) => reduceToSingleDigit(dayOfMonth);
export const NAME_NUMBERS = [1, 2, 3, 4, 5, 6, 7, 8, 9];
//# sourceMappingURL=Numbers.js.map